import React, { useContext } from 'react';
import Context from "../context/context";

function SelectedTopFilter(){

    const {selectedFilters} = useContext(Context);

    let selected_top_filter = "All";
    selectedFilters.forEach((selected_filter) => {
        if (selected_filter.name === "top_filter"){
            selected_filter.elements.forEach((element) => {
                if (element.value) {
                    selected_top_filter = element.title;
                }
            })
        }
    })
    return (
        <>
          {selected_top_filter}
        </>
    )
}

export default SelectedTopFilter;
